<template>
  <div id="app">
    <div class="header">
      <img class="logo" src="static/images/logo_header.png" alt="">
      <div class="consult">业务咨询</div>
      <!-- <div class="languge">EN</div> -->
      <span class="phone">
        <span class="glyphicon glyphicon-earphone"></span>
        <span class="phoneNum">020-22822068</span>
      </span>
      <div class="container">
        <div class="top-nav">
          <nav class="navbar navbar-default">
            <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
              <ul class="nav navbar-nav navbar-right">
                <li v-for="(link,index) in linkList" :key="link.menu">
                  <router-link :to="link.url" :class="$route.meta==index+1?'active':''">{{link.menu}}</router-link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <div class="dropdown header_mobile">
      <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
        <img class="logo" src="static/mbimages/logo_header.png" alt="">
        <img class="glyphicon-th-list" src="static/mbimages/nav.png" alt="">
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
        <li><img height="20px" src="static/mbimages/menu.png" alt=""></li>
        <li v-for="(link,index) in linkList" :key="link.menu" :class="$route.meta==index+1?'isActive':''">
          <router-link :to="link.url">{{link.menu}}</router-link>
          <!-- <div style="height:3px;width:115px;background:#d31521;margin:auto;" ></div> -->
        </li>
      </ul>
    </div>
    <div class="blank"></div>
    <router-view/>
    <div class="introduce">
      <div class="contant">
        <img class="logo" :src="$store.state.isMB?'static/mbimages/logo_footer.png':'static/images/logo_footer.png'" alt="">
        <ul class="product">产品及方案
          <li @click="toPage('/ability')">核心能力</li>
          <li @click="toPage('/insurance')">保险行业</li>
          <li @click="toPage('/afterMarket')">汽车后市场</li>
          <!-- <li>医疗健康</li> -->
        </ul>
        <ul class="findMore">发现更多
          <li @click="toPage('/about')">关于东升</li>
          <li @click="toPage('/joinUs')">加入我们</li>
        </ul>
        <ul class="phone">全国热线电话
          <li>020-22822068</li>
          <li>周一到周五<br class="changeLine">9:30-18:00(北京时间)</li>
        </ul>
        <div class="grayLine"></div>
        <ul class="phoneNaddress">
          <li>汕头：广东省汕头市高新区科技东路7号12层</li>
          <li>电话：0754 - 88168168 / 88268886</li>
          <li class="onlyPC">@ {{new Date().getFullYear()}} 广东东升信息技术有限公司 All rights reserved.<a href="http://beian.miit.gov.cn/" style="margin-left:10px; color:rgba(255,255,255,0.65)">粤ICP备08121390号-13</a></li>
        </ul>
        <ul class="phoneNaddress_bj">
          <li>北京：北京市东三环中路39号建外SOHO东区</li>
          <li>电话：010 - 59009215</li>
          <li class="onlyPC">市场合作：kf@eccc.cc</li>
        </ul>
        <!-- <ul class="phoneNaddress_gz">
          <li>广州：广州市广园东路2193号时代新世界中心北塔2601室</li>
          <li>电话：020 - 22822210</li>
          <li class="onlyPC"><a href="http://beian.miit.gov.cn/" style="color:rgba(255,255,255,0.65)">粤ICP备08121390号</a></li>
        </ul> -->
        <ul class="onlyMB">
          <li>市场合作：kf@eccc.cc</li>
          <li>@ {{new Date().getFullYear()}} 广东东升信息技术有限公司 All rights reserved.</li>
          <li><a href="http://beian.miit.gov.cn/" style="color:rgba(255,255,255,0.65)">粤ICP备08121390号-13</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      linkList: [
        { url: '/index', menu: '首页' },
        { url: '/ability', menu: '核心能力' },
        { url: '/insurance', menu: '保险行业' },
        { url: '/afterMarket', menu: '汽车后市场' },
        // { url: '/', menu: '医疗健康' },
        { url: '/about', menu: '关于东升' },
        { url: '/joinUs', menu: '加入我们' }
      ]
    }
  },
  mounted () {
    window.scroll(0,0)
  },
  methods: {
    toPage (url) {
      this.$router.push(url)
    }
  }
}
</script>
<style lang="scss">
@import "~@/styles/title.scss";
*{
  font-family: sourceHanSansCN-Light, PingFangSC-Regular, Microsoft YaHei, sans-serif;
}
#app{
  @media screen and (min-width: 768px) {
    min-width: 1200px !important;
  }
  @media screen and (max-width: 767px) {
    padding-top: 60px;
  }
}
.blank{
  height: 80px;
  @media screen and (max-width: 1199px) {
    height: 0;
  }
}
.open{
  .dropdown-toggle{
    background: #222 !important;
  }
}
.header_mobile{
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
  @media screen and (min-width: 768px) {
    display: none;
  }
  .logo{
    @media screen and (max-width: 767px) {
      height: 36px;
      margin-top: 3px;
    }
  }
  .dropdown-toggle{
    width: 100%;
    background: #222;
    color: #fff;
    display: flex;
    justify-content: space-between;
    height: 60px;
    border: none;
    border-radius: 0;
    .glyphicon-th-list{
      margin-top: 13px;
      width: 20px;
    }
  }
  .dropdown-menu{
    width: 100%;
    margin-top: 8px;
    letter-spacing: 4px;
    height: 100vh;
    background: rgba(0,0,0,0.85);
    text-align: center;
    padding: 0;
    @media screen and (min-width: 768px) and (max-width: 1199px) {
      font-size: 3vw;
      letter-spacing: 1vw;
      margin-top: -4.5vw;
    }
    @media screen and (min-width: 900px) and (max-width: 1199px) {
      margin-top: -6vw;
    }
    li{
      height: 48px;
      width: fit-content;
      margin: 0 auto 5px;
      a{
        line-height: 48px;
        font-size: 16px;
        text-indent: 3px;
      }
    }
    li:nth-of-type(1){
      margin-bottom: 0;
      text-align: right;
      width: 100%;
      padding: 10px 20px 0 0;
      height: 30px;
    }
    .isActive{
      border-bottom: 3px solid red;
    }
  }
}
.header{
  background: #222;
  color: #eee;
  letter-spacing: 3px;
  line-height: 80px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  @media screen and (min-width: 768px) {
    min-width: 1200px !important;
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
  .container{
    margin: 0;
    .top-nav{
      max-width: 70%;
    }
    .navbar-nav{
      display: flex;
      white-space: nowrap;
      margin-left: 12%;
      @media screen and (min-width: 768px) and (max-width: 1365px){
        margin-left: 3%;
      }
      & > li{
        margin-right: 0;
        & > a {
          z-index: 10;
          line-height: 80px;
          height: 80px;
          padding: 0 10px;
          font-size: 16px;
          opacity: 0.65;
          @media screen and (min-width: 768px) and (max-width: 1365px){
            padding: 0 12px;
          }
          &::before{
            background: red;
            height: 2px;
          }
          &:hover{
            opacity: 1;
          }
        }
        .active{
          opacity: 1 !important;
        }
      }
    }
  }
  .logo{
    float: left;
    margin: 22px 0 0 2%;
  }
  .consult{
    color: #fff;
    width: 128px;
    background: red;
    line-height: 80px;
    text-align: center;
    float: right;
    font-weight: bold;
    cursor: pointer;
    margin-left: 3%;
  }
  .languge,.phone{
    float: right;
    opacity: 0.65;
    letter-spacing: 0px;
  }
  .languge{
    margin: 0 40px;
  }
  .phone{
    letter-spacing: 1px;
    transition-duration: 0.5s;
    &:hover{
      opacity: 1;
      transition-duration: 0.5s;
    }
  }
  .glyphicon-earphone{
    color: #eee;
    margin-right: 2px;
  }
}
.introduce{
  background: url('../static/images/bg_footer.png') no-repeat;
  background-size: 100% 100%;
  height: 540px;
  width: 100%;
  @media screen and (max-width: 767px){
    background: url('../static/mbimages/bg_footer.jpg') no-repeat;
    background-position: 5% 60%;
    height: fit-content;
    padding-bottom: 25px;
  }
  .contant{
    width: 1200px;
    @media screen and (max-width: 1199px){
      width: 100%;
      padding: 0 4%;
      height: 100%;
    }
    .grayLine{
      height:1px;
      background: #666;
      margin-top:252px;
      @media screen and (max-width: 767px){
        margin-top: 20px;
      }
    }
    margin: auto;
    position: relative;
    img{
      margin-top: 86px;
      width: 310px;
      @media screen and (max-width: 767px){
        margin-top: 5%;
        width: 55%;
      }
    }
    ul{
      font-size: 16px;
      letter-spacing: 3px;
      padding-left: 0px;
      color: rgba(255,255,255,0.65);
      @media screen and (max-width: 767px){
        font-size: 4vw;
        white-space: nowrap;
        width: 80%;
        display: flex;
      }
      li {
        list-style: none;
        font-size: 14px;
        margin-top: 33px;
        letter-spacing: 0px;
        color: #fff;
        @media screen and (max-width: 767px){
          // font-size: 12px;
          margin-top: 10%;
          margin-right: 10%;
        }
      }
      li:nth-of-type(1){
        @media screen and (min-width: 1200px){
          margin-top: 46px;
        }
      }
      .onlyPC{
        @media screen and (max-width: 767px){
          display: none;
        }
      }
    }
    .product, .findMore, .phone{
      position: absolute;
      top: 90px;
    }
    .product{
      left: 608px;
      @media screen and (max-width: 767px){
        left: 5%;
        top: 11%;
        display: none;
      }
      li:hover{
        text-decoration: underline;
        cursor: pointer;
      }
      li:nth-of-type(1){
        @media screen and (max-width: 767px){
          margin-left: -30%;
        }
      }
    }
    .findMore{
      left: 808px;
      @media screen and (max-width: 1199px){
        left: 5%;
        top: 23%;
        justify-content: flex-start;
        display: none;
      }
      li:hover{
        text-decoration: underline;
        cursor: pointer;
      }
      li:nth-of-type(1){
        @media screen and (max-width: 767px){
          margin-left: -24%;
        }
      }
    }
    .phone{
      left: 980px;
      @media screen and (max-width: 767px){
        width: 100%;
        position: static;
        display: flex;
        justify-content: space-between;
        margin-top: 5%;
      }
       @media screen and (max-width: 374px){
        flex-direction: column;
      }
      li:nth-of-type(1){
        margin-top: 39px;
        font-size: 30px;
        font-weight: bold;
        white-space: nowrap;
        @media screen and (max-width: 767px){
          font-size: 28px;
          margin-top: 10.5%;
          position: absolute;
          left: 4%;
        }
        @media screen and (max-width: 374px){
          top: 85px;
          font-size: 30px;
          margin-top: 4.5%;
        }
      }
      li:nth-of-type(2){
        margin-top: 17px;
        @media screen and (max-width: 767px){
          margin-top: 12%;
          margin-right: 0;
        }
        @media screen and (max-width: 374px){
          margin-top: 70px;
        }
        .changeLine{
          @media screen and (min-width: 767px){
            display: none;
          }
        }
      }
    }
    .phoneNaddress,.phoneNaddress_bj,.phoneNaddress_gz,.onlyMB{
      display: block;
      margin-bottom: 0px;
      @media screen and (max-width: 767px){
        white-space: pre-line;
        width: 100%;
      }
      li{
        color: rgba(255,255,255,0.65);
        margin-top: 12px;
        @media screen and (max-width: 767px){
          margin-right: 0;
        }
      }
      li:nth-of-type(1){
        margin-top: 12px;
      }
      li:nth-of-type(3){
        margin-top: 50px;
        @media screen and (max-width: 767px){
          margin-top: 12px;
        }
      }
    }
    .phoneNaddress_gz,.phoneNaddress_bj,.onlyMB{
      position: absolute;
      right: 0;
      bottom: 2px;
      @media screen and (max-width: 767px){
        position: static;
        margin-top: 10%;
      }
    }
    .phoneNaddress{
      @media screen and (max-width: 767px){
        margin-top: 10%;
      }
    }
    .phoneNaddress_bj{
      left: 600px;
    }
    .onlyMB{
      @media screen and (min-width: 768px){
        display: none;
      }
      li:nth-of-type(1){
        margin-bottom: 10%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue